import React from 'react';
import { Link } from 'react-router-dom';
import './LinkRow.css';

// Generalized from what was ExperienceRow — Side Projects needed the exact
// same shape (a title, a subtitle beside/below it, optional content at the
// far right), so this is shared rather than duplicated.
//
// Two link modes:
// - Default (Experience): only the title links out, row itself isn't
//   clickable, no whole-row hover affordance — the title's own underline is
//   the only hover cue, filling in on hover rather than retracting like
//   .bio-link does, since a standalone row has nothing else competing for
//   attention the way inline body text does.
// - wholeRowClickable (Side Projects): the row itself is the link, title is
//   plain text with no underline — pairs with the glass hover box each
//   section already gets from HighlightedRowList, so the whole highlighted
//   area is actually clickable instead of just the title within it.
const LinkRow = ({ title, url, subtitle, right, stacked = false, onMouseEnter, onMouseLeave, wholeRowClickable = false }) => {
  const isInternal = url.startsWith('/');
  const linkProps = isInternal
    ? { to: url }
    : { href: url, target: '_blank', rel: 'noopener noreferrer' };

  const RowTag = wholeRowClickable ? (isInternal ? Link : 'a') : 'div';
  const rowLinkProps = wholeRowClickable ? linkProps : {};
  const TitleTag = wholeRowClickable ? 'span' : (isInternal ? Link : 'a');
  const titleLinkProps = wholeRowClickable ? {} : linkProps;

  return (
    <RowTag
      className={`link-row${stacked ? ' link-row--stacked' : ''}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      {...rowLinkProps}
    >
      <div className="link-row-text">
        <TitleTag
          className={`link-row-title${wholeRowClickable ? ' link-row-title--static' : ''}`}
          {...titleLinkProps}
        >
          {title}
        </TitleTag>
        {subtitle && <span className="link-row-subtitle">{subtitle}</span>}
      </div>
      {right != null && <span className="link-row-right">{right}</span>}
    </RowTag>
  );
};

export default LinkRow;
